module.exports = __webpack_public_path__ + "img/racecourse-barrowdalePark-turf-1000.7f83b6d8.svg";